import { AccessControl } from 'accesscontrol'
import permissions from './permissions'
import store from '@/store'

const ac = new AccessControl()
ac.setGrants(permissions)
export const allRoles = ac.getRoles()

export function can (queryInfo) {
  const userRole = getUserRole()
  const userPlan = getUserPlan()

  if (!queryInfo) { return new Error('Need queryInfo in can()') }

  if (!userRole) {
    return false
  }

  if (!userPlan) {
    return false
  }

  if (queryInfo) {
    const roleGrant = ac.permission(
      Object.assign({
        role: userRole
      }, queryInfo)).granted

    const planGrant = ac.permission(
      Object.assign({
        role: userPlan
      }, queryInfo)).granted

    return roleGrant && planGrant
  }
}

export async function canRoute (route) {
  if (!route) { return false }

  const permission = route.meta && route.meta.permission

  if (permission) {
    // If doFirstLoad is still loading, just wait
    if (store.state.loading) {
      await new Promise(resolve => {
        const unwatch = store.watch(
          (state) => state.loading,
          (loading) => {
            if (!loading) {
              unwatch()
              resolve()
            }
          }
        )
      })
    }

    const [resource, action = 'read'] = permission.split('.')
    return can({
      resource,
      action,
      possession: 'any'
    })
  } else {
    return true
  }
}

export function getUserRole () {
  const isAdmin = store.state.user.isAdmin
  const role = isAdmin ? 'admin' : 'owner' // store.getters['user/getCurrentUserRole']
  return (allRoles.indexOf(role) > -1) ? role : null
}

function getUserPlan () {
  const plan = store.getters['user/currentUserPlan']
  return (allRoles.indexOf(plan) > -1) ? plan : null
}

export function isOwner () {
  return getUserRole() === 'owner'
}

export default {
  install (Vue, options) {
    Vue.prototype.$can = function (permission) {
      const [resource, action = 'read'] = permission.split('.')
      return can({
        resource,
        action,
        possession: 'any'
      })
    }
  }
}
